import safetyCardTemplate from "./safety_card.html";
import en from "./en.translation.json";
import es from "./es.translation.json";
import { IN_PERSON } from "../../../safety/constants";
import { controllers } from "chart.js";

class SafetyCardController {
    /* @ngInject */
    constructor() {
        this.IN_PERSON = IN_PERSON;
    }
}

export default {
    controller: SafetyCardController,
    bindings: { growers: "<", neededMeetings: "<" },
    template: safetyCardTemplate,
    name: "safetyCard",
    translations: { en, es },
};
